export const imgs = {
  loginBg: require("../imgs/login_bg.jpg"),
  loginLogo: require("../imgs/login_logo.png"),
  logo: require("../imgs/logo.png"),
  exampleImg: require("../imgs/example_img.jpg"),
}